import { render, staticRenderFns } from "./PatientRybelsusTab.vue?vue&type=template&id=c8e99252&scoped=true&"
import script from "./PatientRybelsusTab.vue?vue&type=script&lang=js&"
export * from "./PatientRybelsusTab.vue?vue&type=script&lang=js&"
import style0 from "./PatientRybelsusTab.vue?vue&type=style&index=0&id=c8e99252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e99252",
  null
  
)

export default component.exports